import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IMigFormService, MigFormService } from './services/mig-form.service';
import {
  NgbAccordionModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ArchwizardModule } from 'angular-archwizard';
import { AssistedLivingFormComponent } from './components/assisted-living-form/assisted-living-form.component';
import { FormsModule as CommonFormsModule } from '../../../communities/modules/resident/modules/forms/forms.module';
import { CommonModule } from '@angular/common';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { CommunityPageComponent } from './pages/community-page/community-page.component';
import { CongratulationsPageComponent } from './pages/congratulations-page/congratulations-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { FormFieldBooleanComponent } from './components/form-tools/form-field-boolean/form-field-boolean.component';
import { FormFieldCheckboxComponent } from './components/form-tools/form-field-checkbox/form-field-checkbox.component';
import { FormFieldComponent } from './components/form-tools/form-field/form-field.component';
import { FormFieldDateComponent } from './components/form-tools/form-field-date/form-field-date.component';
import { FormFieldDefaultComponent } from './components/form-tools/form-field-default/form-field-default.component';
import { FormFieldMultiselectComponent } from './components/form-tools/form-field-multiselect/form-field-multiselect.component';
import { FormFieldTextComponent } from './components/form-tools/form-field-text/form-field-text.component';
import { FormFieldTextareaComponent } from './components/form-tools/form-field-textarea/form-field-textarea.component';
import { FormFieldTimeComponent } from './components/form-tools/form-field-time/form-field-time.component';
import { FormFileComponent } from './components/form-tools/form-file/form-file.component';
import { FormGroupComponent } from './components/form-tools/form-group/form-group.component';
import { FormPageComponent } from './pages/form-page/form-page.component';
import { FormSectionComponent } from './components/form-tools/form-section/form-section.component';
import { FormTypeComponent } from './components/basic-data/form-type/form-type.component';
import { FormTypePageComponent } from './pages/form-type-page/form-type-page.component';
import { FormsDirective } from './directives/forms.directive';
import { HeaderAuthInterceptor } from '@interceptors/header-auth.interceptor';
import { InitialDataFormComponent } from './components/basic-data/initial-data-form/initial-data-form.component';
import { LayoutModule } from '../layout/layout.module';
import { MemoryCareFormComponent } from './components/memory-care-form/memory-care-form.component';
import { MigCommunitiesGuard } from './guards/mig-communities.guard';
import { MigCorporationGuard } from './guards/mig-corporation.guard';
import { MigForm } from '@models/forms/mig-form.model';
import { MigFormComponent } from './mig-form.component';
import { MigFormGuard } from './guards/mig-form.guard';
import { MigFormRoutingModule } from './mig-form-routing.module';
import { MigResidentGuard } from './guards/mig-resident.guard';
import { ModelService } from '@services/common/model.service';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ResidentNameComponent } from './components/basic-data/resident-name/resident-name.component';
import { ResidentPageComponent } from './pages/resident-page/resident-page.component';
import { RouterModule } from '@angular/router';
import { RouterPageComponent } from './pages/router-page/router-page.component';
import { SizeDirective } from './directives/size.directive';
import { TranslateModule } from '@ngx-translate/core';
import { WizardPageComponent } from './pages/wizard-page/wizard-page.component';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [
    MemoryCareFormComponent,
    AssistedLivingFormComponent,
    MigFormComponent,
    InitialDataFormComponent,
    FormTypeComponent,
    ResidentNameComponent,
    FormsDirective,
    FormFieldComponent,
    FormGroupComponent,
    FormSectionComponent,
    FormFieldDefaultComponent,
    FormFieldDateComponent,
    FormFieldBooleanComponent,
    FormFieldCheckboxComponent,
    FormFieldMultiselectComponent,
    FormFieldTextComponent,
    FormFieldTextareaComponent,
    SizeDirective,
    FormFileComponent,
    FormFieldTimeComponent,
    WizardPageComponent,
    DashboardPageComponent,
    CommunityPageComponent,
    ResidentPageComponent,
    FormTypePageComponent,
    FormPageComponent,
    ErrorPageComponent,
    RouterPageComponent,
    CongratulationsPageComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,

    MigFormRoutingModule,

    RouterModule,
    TranslateModule,
    NgbDropdownModule,
    LayoutModule,
    ArchwizardModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbTooltipModule,
    NgxDropzoneModule,
    HttpClientModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FlatpickrModule.forRoot(),
    NgxSpinnerModule,
    CommonFormsModule,
    NgbAccordionModule,
    AlertModule,
  ],
  providers: [
    CommonVerbsApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderAuthInterceptor,
      multi: true,
    },
    {
      provide: 'ID_ASSISSTED_LIVING_MIG_FORM',
      useValue: environment.assisstedLivingMigFormId,
    },
    {
      provide: 'ID_MEMORY_CARE_MIG_FORM',
      useValue: environment.memoryCareMigFormId,
    },
    {
      provide: 'MigFormService',
      useFactory: () => new ModelService<MigForm>(),
    },
    {
      provide: IMigFormService,
      useClass: MigFormService,
    },

    MigCorporationGuard,
    MigCommunitiesGuard,
    MigResidentGuard,
    MigFormGuard,
  ],
})
export class MigFormModule {}
